import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { onlineTourDetailPage } from '../api';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IOnlineTourSearchResult } from '../utils/types';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import OnlineTourDetailPrintOutContainer from '../container/OnlineTourDetailPrintOutContainer';

function OnlineTourDetailPrintOutPage() {
  const { id } = useParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [onlineSearchResult, setOnlineSearchResult] = useState<
    IOnlineTourSearchResult[]
  >([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && onlineSearchResult.length === 0) {
      setTimeout(() => {
        navigate('/home');
      }, 3000);
    }
  }, [loading, onlineSearchResult.length, navigate]);

  useEffect(() => {
    fetchDetail(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchDetail = async (tourId: string | undefined) => {
    try {
      const response = await onlineTourDetailPage(parseInt(tourId as string));
      const data = await response.json();
      setOnlineSearchResult(data);
    } catch (error) {
      console.error('Error fetching tour detail:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      {!loading && (
        <>
          {onlineSearchResult.length > 0 && (
            <OnlineTourDetailPrintOutContainer
              onlineSearchResult={onlineSearchResult}
              tourId={parseInt(id as string)}
            />
          )}
        </>
      )}
    </Box>
  );
}

export default OnlineTourDetailPrintOutPage;
